import Constants from 'expo-constants'

import { Configuration } from '../api'
import { addBreadcrumb, sanitize } from '../utils/sentry'

let currentAccessToken: string | null = null

const apiConfig = Constants.expoConfig?.extra?.api
const API_BASE_URL = apiConfig?.url ?? 'http://localhost:3000'

export const setAccessToken = (token: string | null) => {
  currentAccessToken = token
  addBreadcrumb('api', 'access_token_updated', {
    token: sanitize.token(token),
  })
}

export const getApiConfig = () => {
  return new Configuration({
    basePath: API_BASE_URL,
    accessToken: currentAccessToken || undefined,
    headers: currentAccessToken
      ? {
          Authorization: `Bearer ${currentAccessToken}`,
        }
      : undefined,
  }) satisfies Configuration
}
